// TODO: It's likely that we may want parts of this to be
// in a provider + context, instead of a zustand store.

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export enum ToolboxSection {
  Pinned = 'pinned',
  Rubric = 'rubric',
}

export enum ChatLayout {
  Inline = 'inline',
  MultiColumn = 'multicolumn',
}

export type ChatLayoutStore = {
  layout: ChatLayout | null | undefined;
  setLayout: (layout: ChatLayout | null) => void;

  showConfig: boolean;
  toggleShowConfig: () => void;

  isDrawerOpen: boolean;
  hasDrawerBeenOpened: boolean;
  setIsDrawerOpen: (open: boolean) => void;

  selectedToolboxTab: ToolboxSection;
  setSelectedToolboxTab: (section: ToolboxSection) => void;

  drawerWidth: number;
  setDrawerWidth: (width: number) => void;
  getCurrentDrawerWidth(): number;

  columnWidth: number;
  setColumnWidth: (width: number) => void;

  isContentExpanded: boolean;
  toggleContentExpanded: () => void;

  resetHasDrawerBeenOpened: () => void;
};

const DEFAULT_COLUMN_WIDTH = 640;
const DEFAULT_DRAWER_WIDTH = 800;

const initialState = {
  layout: null,
  showConfig: false,
  isDrawerOpen: false,
  hasDrawerBeenOpened: false,
  selectedToolboxTab: ToolboxSection.Pinned,
  drawerWidth: DEFAULT_DRAWER_WIDTH,
  columnWidth: DEFAULT_COLUMN_WIDTH,
  isContentExpanded: false,
};

export const useChatLayoutStore = create<ChatLayoutStore>()(
  devtools(
    (set, get) => ({
      ...initialState,
      setLayout: (layout: ChatLayout | null) => {
        set({ layout }, false, 'setLayout');
      },
      toggleShowConfig: () => {
        set(state => ({ showConfig: !state.showConfig }), false, 'toggleShowConfig');
      },
      setIsDrawerOpen: (open: boolean) => {
        if (open) {
          set({ hasDrawerBeenOpened: true, isDrawerOpen: open }, false, 'setIsDrawerOpen');
        }
        set({ isDrawerOpen: open }, false, 'setIsDrawerOpen');
      },
      setSelectedToolboxTab: (section: ToolboxSection) => {
        set({ selectedToolboxTab: section }, false, 'setSelectedToolboxTab');
      },
      setDrawerWidth: (width: number) => {
        set({ drawerWidth: width }, false, 'setDrawerWidth');
      },
      setColumnWidth: (width: number) => {
        set({ columnWidth: width }, false, 'setColumnWidth');
      },
      getCurrentDrawerWidth: () => {
        const { isDrawerOpen, drawerWidth } = get();
        return isDrawerOpen ? drawerWidth : 0;
      },
      toggleContentExpanded: () => {
        set(
          state => ({ isContentExpanded: !state.isContentExpanded }),
          false,
          'toggleContentExpanded',
        );
      },
      resetHasDrawerBeenOpened: () => {
        set({ hasDrawerBeenOpened: false }, false, 'resetHasDrawerBeenOpened');
      },
    }),
    {
      name: 'chat-pin-store',
    },
  ),
);
